import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import FilesTab from './FilesTab';
import SharedWithMeTab from './SharedWithMeTab';
import { Files, Inbox } from 'lucide-react';

// E-sign templates, patient forms and signed documents moved to the
// dedicated Forms page (/app/forms).

const TABS = [
  { key: 'files',  label: 'Files',          Icon: Files },
  { key: 'shared', label: 'Shared with me', Icon: Inbox },
];

export default function DocumentsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(TABS.some(t => t.key === requested) ? requested : 'files');

  const switchTab = (tab) => { setActiveTab(tab); setSearchParams({ tab }); };

  return (
    <div className="flex-1 bg-primary">
      <div className="max-w-[960px] mx-auto px-4 md:px-7 py-6">
        <h1 className="text-[22px] font-bold text-primary-c mb-1">Documents</h1>
        <p className="text-[12px] text-muted-c mb-6">
          Upload files and share them securely with partner organizations.
        </p>

        <div className="flex bg-tertiary rounded-[10px] p-1 mb-6 w-fit overflow-x-auto">
          {TABS.map(t => (
            <button
              key={t.key}
              onClick={() => switchTab(t.key)}
              className={`px-5 py-2.5 rounded-[7px] text-[13px] font-medium transition-all flex items-center gap-1.5 whitespace-nowrap ${
                activeTab === t.key
                  ? 'bg-accent text-white shadow-glow'
                  : 'text-muted-c hover:text-primary-c'
              }`}
            >
              <t.Icon size={14} strokeWidth={2.2} />
              {t.label}
            </button>
          ))}
        </div>

        {activeTab === 'files' && <FilesTab />}
        {activeTab === 'shared' && <SharedWithMeTab />}
      </div>
    </div>
  );
}
